// Hosts the Dream Cafe remake (public/dream-cafe/, exported from the DreamCafe project) at /dream-cafe.
// Amplify's SPA rewrite sends .html requests to this app, so the game's page ships as index.txt
// and is mounted here in place of the portfolio.
export const DREAM_CAFE_PATH = /^\/dream-cafe(\/(index\.html)?)?$/;

export async function mountDreamCafe() {
  const root = '/dream-cafe/';
  // Drop the portfolio's CSS, icons and manifest; the game brings its own.
  document.head.querySelectorAll('link, style, meta[name="theme-color"], meta[name="description"]').forEach((n) => n.remove());
  const base = document.createElement('base');
  base.href = root;
  document.head.prepend(base);
  document.documentElement.dataset.audioExt = '.mp3.json';

  const res = await fetch(root + 'index.txt', { cache: 'no-cache' });
  const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
  document.title = doc.title;
  doc.head.querySelectorAll('link, meta[name="theme-color"], meta[name="description"]').forEach((n) => {
    document.head.append(document.importNode(n, true));
  });
  const nodes = Array.from(doc.body.childNodes).filter((n) => n.nodeName !== 'SCRIPT');
  document.body.replaceChildren(...nodes.map((n) => document.importNode(n, true)));

  const script = document.createElement('script');
  script.type = 'module';
  script.src = root + 'js/main.js';
  document.body.append(script);
}
